<template>
  <div v-if="show_body" class="test-list">
    <!-- 进度 -->
    <div class="progress" :style="{width: progress}"></div>
    <!-- 开始 -->
    <div ref="topic-header">
      <!-- 头部 -->
      <div
        v-if="!lock && intro !=''"
        class="item-answer-left-animation item-inter inter-left pd32 clearfix"
      >
        <div class="pull-left ico-box">
          <img src="@a/cep_logo.png" alt />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>{{intro}}</p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- list -->
    <div v-for="(item, index) in list" :key="index+''">
      <!-- 数据渲染部分 -->
      <div ref="item-yield" v-show="yieldIndex + 2 >= index+1">
        <div
          v-show="yieldIndex >= index && !lock"
          :class="[yieldIndex >= index && !lock ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']"
        >
          <div class="pull-left ico-box">
            <img src="@a/cep_logo.png" alt />
          </div>
          <div class="item-text pull-left pr">
            <div class="alert-con item-radius">
              <p>{{item.question}}</p>
            </div>
            <div class="caret pa"></div>
          </div>
        </div>
        <!-- item-right -->
        <div
          v-show="yieldIndex >= index && !lock"
          :class="[yieldIndex >= index && !lock ? 'item-answer-right-animation' : '','item-inter inter-right pt32']"
        >
          <div class="clearfix">
            <div class="pull-right ico-box">
              <img :src="headimgurl" alt />
            </div>
            <div class="item-text pull-right pr">
              <div class="alert-con item-radius">
                <van-radio-group class="alert-radio-group" v-model="item.radio">
                  <van-cell-group>
                    <van-cell
                      v-for="item2 in item.options"
                      :key="item[1]"
                      :class="item.radio === item2[1] ? 'active' : ''"
                      :title="item2[0]"
                      clickable
                      @click="selectItemRadio(item, item2, index)"
                    >
                      <van-radio :checked-color="'#F57F17'" :name="item2[1]" />
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
              </div>
              <div class="caret pa"></div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
    <!-- 结束 -->
    <div v-show="showFooter">
      <div
        ref="cart-footer"
        :class="[showFooter ? 'item-answer-left-animation' : '', 'item-inter inter-left mt32 clearfix']"
      >
        <div class="pull-left ico-box">
          <img src="@a/cep_logo.png" alt />
        </div>
        <div class="item-text pull-left pr">
          <div class="alert-con item-radius">
            <p>已完成全部测评！点击领取你的专业报告。</p>
            <p @click="over_click" class="text-right next-box">生成报告 ></p>
          </div>
          <div class="caret pa"></div>
        </div>
      </div>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <!-- <img src="../../../assets/cep_ewm.png" /> -->
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt />
        </div>
      </div>
    </van-popup>
    <!-- 填写信息 -->
    <van-popup class="radius pops" v-model="isMsg" :close-on-click-overlay="false" v-if="extra">
      <van-cell-group>
        <van-field v-model="username" required :label="extra.name" :placeholder="'请输入'+extra.name" />
        <van-field v-model="phone" :label="extra.phone" :placeholder="'请输入'+extra.phone" required />
      </van-cell-group>
      <h4>{{data.extra_tip}}</h4>
      <a @click="submit" v-if="username!='' && phone != ''">提交</a>
      <a v-else class="over">提交</a>
    </van-popup>
    <!-- 未购买 -->
    <van-popup class="pub_alert" v-model="is_buy" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <router-link class="confirm" :to="{
            path:'/course_details',
            query:{
              bid:2
            }
          }">购买最佳工作模式课程</router-link>
        </div>
      </div>
    </van-popup>
    <!-- 是否是本期次的学员 -->
    <van-popup class="pub_alert" v-model="periodOfTime" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>{{periodOfVal}}</h2>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { phoneValidation } from "@/utils/validation";
import {
  ceping61_index,
  ceping61_answer,
  ceping61_report,
  ceping_event,
} from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
import { isMain, getStorage, setStorage,deleteStorage } from "@/utils/tools";
export default {
  data() {
    return {
      show_body: false,
      //
      lock: false,
      //
      yieldIndex: 0,
      // 状态
      ctype: 1,
      //
      headimgurl: "",
      headtitle: "职业价值观测评",
      nickname: "",
      list: [],
      showFooter: false,
      data: {},
      isShow: false,
      type_obj: {
        evaluation_id: "",
        evaluation_name: "",
        evaluation_id: ""
      },
      intro: "",
      qrcode: "",
      show: false,
      isMsg: false,
      username: "",
      phone: "",
      extra: {},
      // 上一页面路由
      formPath:'',
      is_buy:false,
      // 判断是否是本期次
      periodOfTime:false,
      periodOfVal:''
    };
  },
  computed: {
    progress() {
      return (Math.floor((this.yieldIndex / (this.list.length - 1)) * 100)>100?100:Math.floor((this.yieldIndex / (this.list.length - 1)) * 100) ) + '%';
    },
    is_main() {
      return isMain();
    }
  },
  methods: {
    selectItemRadio(item, item2, index) {
      setStorage(this.$route.path, String(item.cid)+String(item.id), item2[1]);
      // 如果没有选择
      let isLastEl = index + 1 < this.list.length;
      if (!item.radio && isLastEl) {
        this.yieldIndex++;
        this.setScrollTo(index);
      }
      // 最后一个
      if (!item.radio && !isLastEl) {
        this.yieldIndex++;
        this.showFooter = true;
        let el = this.$refs["cart-footer"];
        this.setScrollTo(false, true, el);
      }

      // 赋值
      item.radio = item2[1];
      let is_complete = index == this.list.length - 1 ? true : false;

      this.$forceUpdate();

      //神策统计--选择选项时触发
      // sensors.track("doQuestions", {
      //   evaluation_id: this.data.cid + "",
      //   evaluation_name: this.data.headtitle,
      //   questions_number: (this.data.progress += 1),
      //   questions_topic: item.question,
      //   questions_option: item2[0],
      //   is_complete_question: is_complete,
      //   share_user_id: this.$route.query.share_uid
      //     ? this.$route.query.share_uid
      //     : "",
      //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
      // });
    },
    setScrollTo(index, bool, el) {
      setTimeout(() => {
        let elTop = bool? el.offsetTop - 10: this.$refs["item-yield"][index + 1].offsetTop - 10;
        let scroll = document.documentElement.scrollTop? document.documentElement: document.body;
        // window.scrollTo(0, elTop);
        window.scrollTo({
          top: elTop,
          behavior: "smooth"
        });
      }, 50);
    },
    startTest() {
      setTimeout(() => {
        this.lock = false;
        let el = this.$refs["topic-header"];
        this.setScrollTo(0, true, el);
      }, 50);
    },
    createData() {
      let arr = [];
      for (let arg of this.list) {
        arr.push({
          qid: arg.id,
          cid: arg.cid,
          eid: arg.eid,
          score: arg.radio
        });
      }
      return arr;
    },
    over_click() {
      let q = this.$route.query;
      let result = this.createData();
      let answ = { answer: JSON.stringify(result) };

      if (this.extra) {
        answ[this.extra.name] = this.username;
        answ[this.extra.phone] = this.phone;
      }
      ceping61_answer(answ).then(data => {
        let q = this.$route.query;
        // 提交删除缓存 
        deleteStorage(this.$route.path);
        if (this.data.need_subscribe && !this.data.subscribe) {
          this.isShow = true;
        } else {
          if(this.formPath==='/ceping61_report'){
            this.$router.back(); 
          }else{
            this.$router.push("/ceping61_report");
          }
        }
      });
    },
    pullData() {
      let q = this.$route.query;
      ceping61_index({
        share_uid: q.share_uid || "",
        channel: q.channel || ""
      }).then(data => {
        if (data.code != "10002") {
          document.getElementsByTagName("body")[0].style.height =
            window.innerHeight + "px";
          document.title = data.headtitle;
          this.data = data;
          if(data.show_msg){
            this.periodOfTime = true;
            this.periodOfVal = data.msg;
          }else{
            this.is_buy = !data.is_buy;   
          }
          this.headimgurl = data.headimgurl;
          this.headtitle = data.headtitle;
          this.nickname = data.nickname;
          this.intro = data.intro;
          this.qrcode = data.qrcode;
          this.isMsg = true;
          this.extra = data.extra;
          //
          for (let arg of data.list) {
            arg.show = false;
            arg.radio = 0;
          }

          this.list = data.list;
          // 去取缓存已经答完题的数据
          let index_ = null;
          this.list.forEach((item,index)=>{
            item['radio'] = getStorage(this.$route.path, String(item.cid)+String(item.id));
            if(getStorage(this.$route.path, String(item.cid)+String(item.id)) || String(getStorage(this.$route.path, String(item.cid)+String(item.id)))==='0'){
              index_= index;
            }
          });
          // 如果以有缓存就显示下一个故+1
          this.yieldIndex+=!index_&&index_!=0?0:(index_+1);
           if(index_){
            this.setScrollTo((index_+1)==this.list.length?index_-1:index_);
          }
          let  isLastEl= index_ + 1 < this.list.length;
          // 最后一个
          if (!isLastEl) {
            this.showFooter = true;
          }

          this.show_body = true;

          ceping_event({ lead_sid: this.$route.query.lead_sid,
            cid: data.cid,
            event: 'ViewIndex',
          }).then(res=>{
            // 页面访问统计
          });

          // 神策统计--打开页面时触发
          // sensors.track("evaluationPage", {
          //   evaluation_id: data.cid + "",
          //   evaluation_name: this.data.headtitle,
          //   evaluation_url: window.location.href,
          //   evaluation_page_title: this.data.headtitle,
          //   share_user_id: this.$route.query.share_uid? this.$route.query.share_uid: "",
          //   channel_name: this.$route.query.channel? this.$route.query.channel: ""
          // });
          // 给wxconfig传对象
          this.type_obj.nickname = data.nickname;
          this.type_obj.evaluation_id = data.cid + "";
          this.type_obj.evaluation_name = data.headtitle;
          this.type_obj.evaluation_user_id = String(data.uid);
          this.type_obj.path = this.$route.path;

          shareCon("ceping57", this, this.type_obj);
        } else {
          if(this.formPath==='/ceping61_report'){
            this.$router.back(); 
          }else{
            // 已经测评完成
            this.$router.push("/ceping61_report");
          }
        }
      });
    },
    submit() {
      if (phoneValidation(this.phone)) {
        this.isMsg = false;
      } else {
        this.$toast("您输入的手机号不正确！/(ㄒoㄒ)/~~");
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
      vm.formPath = from.path;
    })
  },
  created() {
    this.pullData();
  }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.qr-box {
  width: 600px;
}

.test-list {
  padding: 32px;
  overflow-x: hidden;
  padding-bottom: 750px;
}

.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: #f57f17;
  transition: all 0.3s;
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425) + px;
}

.item-inter {
  transform: translateY(0px);
  opacity: 0;
  .ico-box {
    width: changeRem(1.75) + px;
    height: changeRem(1.75) + px;
    border-radius: changeRem(1.75) + px;
    overflow: hidden;
    img {
      max-width: 100%;
    }
  }
  .pd-row-2 {
    margin-top: 24px;
  }
  .item-text {
    font-size: changeRem(0.6) + px;
  }
  .item-radius {
    border-radius: changeRem(0.17) + px;
  }
  .alert-con {
    overflow: hidden;
  }
  .active_a {
    color: #eb5032;
    text-decoration: underline;
  }
}

/* 左 */

.inter-left {
  .ico-box {
    left: 5px;
    top: 5px;
  }
  .item-text {
    margin-left: changeRem(0.5) + px;
    max-width: 465px;
    color: #fff;
  }
  .alert-con {
    padding: changeRem(0.425) + px;
    background: #f57f17;
  }
  .caret {
    width: 0px;
    height: 0px;
    left: changeRem(-0.3) + px;
    top: changeRem(0.1) + px;
    margin-top: changeRem(0.7) + px;
    border-top: changeRem(0.2) + px solid rgba(0, 160, 246, 0);
    border-right: changeRem(0.3) + px solid rgba(245, 127, 23, 1);
    border-bottom: changeRem(0.2) + px solid rgba(0, 160, 246, 0);
  }
}

/* 右 */

.inter-right {
  .item-text {
    margin-right: changeRem(0.5) + px;
  }
  .alert-con {
    background: #fff;
  }
  .caret {
    width: 0px;
    height: 0px;
    right: changeRem(-0.3) + px;
    top: changeRem(0.1) + px;
    margin-top: changeRem(0.7) + px;
    border-top: changeRem(0.2) + px solid rgba(255, 255, 255, 0);
    border-left: changeRem(0.3) + px solid rgba(255, 255, 255, 1);
    border-bottom: changeRem(0.2) + px solid rgba(255, 255, 255, 0);
  }
}

.next-box {
  border-top: 2px solid #fff;
  margin-top: changeRem(0.35) + px;
  padding-top: changeRem(0.35) + px;
}

.item-answer-left-animation {
  animation: item-answer-animation 0.8s;
  animation-fill-mode: forwards;
}

.item-answer-right-animation {
  animation: item-answer-animation 0.8s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #f57f17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}
.confirm_box {
  h2 {
    padding-bottom: 12px;
    padding: 40px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      width: 100%;
    }
  }
}
</style>
<style>
.active {
  color: #f57f17;
  font-weight: bold;
}

.alert-radio-group .van-cell {
  font-size: 0.37rem;
  line-height: 0.64rem;
  position: relative;
  border-bottom: 2px solid #ddd;
}

.alert-radio-group .van-cell:last-child {
  border-bottom: none;
}

.alert-radio-group .van-radio__icon {
  height: 0.55rem;
  line-height: 0.53rem;
}

.alert-radio-group .van-cell__title {
  position: relative;
  z-index: 1;
}

.alert-radio-group .van-radio__icon .van-icon {
  width: 0.53rem;
  height: 0.53rem;
  border-width: 2px;
}

.alert-radio-group [class*="van-hairline"]::after {
  border: none;
}

.alert-radio-group .van-cell:not(:last-child)::after {
  border: none;
}

.alert-radio-group .van-cell__title span {
  display: block;
  width: 6rem;
  /*margin-right: -0.6rem;*/
  padding-right: 0.65rem;
}

.van-cell__value {
  overflow: initial;
}

.van-radio {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.pops {
  padding: 40px;
  width: 600px;
  text-align: center;
}

.van-hairline--top-bottom::after {
  border-width: 0;
}

.van-field__label {
  text-align: left;
}

.pops a {
  display: inline-block;
  width: 500px;
  line-height: 60px;
  background: #eb5032;
  text-align: center;
  border-radius: 16px;
  color: #fff;
  margin-top: 30px;
  font-size: 28px;
}

.pops a.over {
  background: #ccc;
}
.pops h4 {
  line-height: 60px;
  text-align: left;
  color: #eb5032;
  font-size: 24px;
  margin-top: 10px;
}

/* 动画 */

@keyframes item-answer-animation {
  0% {
    transform: translateY(80px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>
